import _ from "lodash";
import { formatDDMMYYYYToIsoDate } from "@/utils/formats.js";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  data: () => ({
    formatDDMMYYYYToIsoDate
  }),
  mixins: [DocumentsMixin],
  methods: {
    submitFiles(item) {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(item, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE])
        )
      );
    },
    submitZipFiles(item) {
      const { uploadAndExtractZipFile } = this;
      return Promise.all(
        _.map(item, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadAndExtractZipFile(document.arquivo[FILE])
        )
      );
    },
    submitFilesWithFormat(item) {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(item, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                arquivo
              }))
        )
      );
    },
    getProcessQuotation(form, options) {
      // Se não tiver tipo do processo, devo passar null, em vez de passar os valores das keys como null
      if (!options.processo.numero_processo.obrigatorio) {
        return null;
      }
      // Cópia para não alterar meu formulário
      let process = _.cloneDeep(form.processo);
      // Caso o processo não tiver um tipo, preciso passar o tipo_processo null em vez de apenas o id
      if (
        (process.tipo_processo && process.tipo_processo.id == null) ||
        !options.processo.tipo_processo.obrigatorio
      ) {
        process.tipo_processo = null;
      }
      if (options.processo.tribunal.nome_livre) {
        process.tribunal = null;
        process.unidade = null;
      } else {
        process.nome_tribunal = null;
        process.nome_unidade = null;
      }
      return process;
    },
    async getPayloadPolicy(form, options = null) {
      let payload = _.cloneDeep(form);
      if (options) payload.processo = this.getProcessQuotation(form, options);
      if (payload.tribunal?.nome == null) payload.tribunal = null;
      if (payload.unidade?.nome == null) payload.unidade = null;
      payload.apolice = await this.submitFiles(form.apolice);
      payload.arquivo = payload.apolice[0];
      payload.boletos = await this.submitFiles(form.boletos);
      if (payload.data_prorrogacao)
        payload.data_prorrogacao = this.formatDDMMYYYYToIsoDate(
          payload.data_prorrogacao
        );
      if (payload.cancelada_em)
        payload.cancelada_em = this.formatDDMMYYYYToIsoDate(
          payload.cancelada_em
        );
      if (payload.baixada_em)
        payload.baixada_em = this.formatDDMMYYYYToIsoDate(payload.baixada_em);
      if (payload.data_vencimento)
        payload.data_vencimento = this.formatDDMMYYYYToIsoDate(
          payload.data_vencimento
        );
      payload.emitida_em = this.formatDDMMYYYYToIsoDate(payload.emitida_em);
      payload.fim_vigencia = this.formatDDMMYYYYToIsoDate(payload.fim_vigencia);
      payload.inicio_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.inicio_vigencia
      );
      payload.parcelas.forEach((item, key) => {
        item.vencimento = this.formatDDMMYYYYToIsoDate(item.vencimento);
        item.numero = `${key + 1}`;
      });
      return payload;
    },
    async getPayloadInvoice(form) {
      let payload = _.cloneDeep(form);
      payload.documentos = await this.submitFiles(form.documentos);
      payload.arquivo = payload.documentos[0];
      payload.boletos = await this.submitFiles(form.boletos);
      payload.data_emissao = this.formatDDMMYYYYToIsoDate(payload.data_emissao);
      payload.data_vencimento = this.formatDDMMYYYYToIsoDate(
        payload.data_vencimento
      );
      payload.data_fechamento = this.formatDDMMYYYYToIsoDate(
        payload.data_fechamento
      );
      return payload;
    },
    async getPayloadEndorsement(form) {
      let payload = _.cloneDeep(form);
      payload.apolice = await this.submitFiles(form.apolice);
      payload.arquivo = payload.apolice[0];
      payload.boletos = await this.submitFiles(form.boletos);
      payload.anexos = await this.submitFiles(form.anexos);
      if (payload.data_prorrogacao)
        payload.data_prorrogacao = this.formatDDMMYYYYToIsoDate(
          payload.data_prorrogacao
        );
      if (payload.cancelado_em)
        payload.cancelado_em = this.formatDDMMYYYYToIsoDate(
          payload.cancelado_em
        );
      if (payload.fim_vigencia_atual)
        payload.fim_vigencia_atual = this.formatDDMMYYYYToIsoDate(
          payload.fim_vigencia_atual
        );
      if (payload.baixada_em)
        payload.baixada_em = this.formatDDMMYYYYToIsoDate(payload.baixada_em);
      if (payload.novo_fim_vigencia)
        payload.novo_fim_vigencia = this.formatDDMMYYYYToIsoDate(
          payload.novo_fim_vigencia
        );
      payload.emitida_em = this.formatDDMMYYYYToIsoDate(payload.emitida_em);
      payload.fim_vigencia = this.formatDDMMYYYYToIsoDate(payload.fim_vigencia);
      payload.inicio_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.inicio_vigencia
      );
      if (payload.parcelas) {
        payload.parcelas.forEach((item, key) => {
          item.vencimento = this.formatDDMMYYYYToIsoDate(item.vencimento);
          item.numero = `${key + 1}`;
        });
      }
      payload.tipos_efeitos = [];
      if (payload.tipo_efeito_termino)
        payload.tipos_efeitos.push(payload.tipo_efeito_termino);
      if (payload.tipo_efeito_vigencia)
        payload.tipos_efeitos.push(payload.tipo_efeito_vigencia);
      if (payload.tipo_efeito_cobertura)
        payload.tipos_efeitos.push(payload.tipo_efeito_cobertura);
      return payload;
    },
    async getPayloadRequestEndorsement(form) {
      let payload = _.cloneDeep(form);
      if (payload.novo_fim_vigencia)
        payload.novo_fim_vigencia = this.formatDDMMYYYYToIsoDate(
          payload.novo_fim_vigencia
        );
      payload.anexos = await this.submitFiles(form.anexos);
      return payload;
    },
    async getPayloadInactivate(form) {
      let payload = _.cloneDeep(form);
      payload.anexos = await this.submitFiles(form.anexos);
      payload.inativada_em = this.formatDDMMYYYYToIsoDate(payload.inativada_em);
      return payload;
    }
  }
};
